import { render, staticRenderFns } from "./ChecklistNoVirus.vue?vue&type=template&id=3be4c5e8&"
import script from "./ChecklistNoVirus.vue?vue&type=script&lang=js&"
export * from "./ChecklistNoVirus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports